import React, { Component } from 'react';
import { Modal, Checkbox, message } from 'antd';

const digitArr = Array.of('一', '二', '三', '四');

class SetServerModule extends Component {
    state = {
        modules: [],
        visible: false,
        loading: false,
    }

    show = (modules) => {
        this.setState({
            visible: true,
            modules: JSON.parse(JSON.stringify(modules)),
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { modules } = this.state;
        this.props.loadModules(modules);
        this.hide();
    }

    handleCheckChange = (e, index) => {
        const { modules } = this.state;
        modules[index].checked = e.target.checked;
        this.setState({ modules });
    }

    getContent = () => {
        const { modules } = this.state;
        let i = 1;
        return (
            <div style={{ paddingLeft: 20, overflow: 'hidden' }}>
                {
                    modules.map((item, index) => {
                        const { name, checked, disabled, optional } = item;
                        let title = '';
                        if (optional) {
                            title = `可选部分：${name}`;
                        } else {
                            title = `第${ digitArr[i - 1] }部分：${name}`;
                            i++;
                        }
                        return (
                            <div key={name} style={{width: '100%', marginTop: 10}}>
                                <Checkbox
                                    checked={checked}
                                    disabled={disabled}
                                    onChange={(e) => this.handleCheckChange(e, index)}
                                >{title}</Checkbox>
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="设置服务报价模块"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                width="500px"
                confirmLoading={loading}
            >
                <div style={{ padding: '0px 10px 10px' }}>
                    <div style={{ padding: 10, background: '#f1f1f1' }}>请选择服务报价模块</div>
                    {this.getContent()}
                </div>
            </Modal>
        )
    }
}

export default SetServerModule;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Components/SetServerModule.js